// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3yUGE","approved":"Status_approved__1yUKe","rejected":"Status_rejected__mCLi_","expired":"Status_expired__VDxuz","label":"Status_label__3cAWi"};